import {HTMLAttributes} from 'react';
import {requestContext} from '../../../../common/requestContext';
import {twMerge} from '../../../../common/twMerge';
import {ContentHomeTabWrapper} from '../../../../design-system/organisms/ContentHomeTabWrapper/ContentHomeTabWrapper';
import {ApiErrorBoundary} from '../../../../errors/ApiErrorBoundary.class';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {ReactQueryFetcher} from '../../../../reactQuery/ReactQueryFetcher';
import {
  useContentHomeInfoQuery,
  useContentHomeOverviewQuery,
} from '../../../../wrapper/contentWrapper';
import {ContentHomeAboutContainer} from './ContentHomeAboutContainer';

export interface ContentDetailTabContainerProps
  extends HTMLAttributes<HTMLDivElement> {
  seriesId: number;
}

export function ContentDetailTabContainer({
  seriesId,
  ...props
}: ContentDetailTabContainerProps) {
  const {isMobile} = requestContext.requestInfo.display;
  const overview = useContentHomeOverviewQuery({seriesId}, ONLY_DATA_CONFIG)
    .data?.contentHomeOverview;

  return (
    <ContentHomeTabWrapper
      isMobile={isMobile}
      displayAd={overview?.displayAd}
      saleState={overview?.content?.saleState}
      {...props}
    >
      <ApiErrorBoundary
        className={isMobile ? undefined : 'bg-theme-bg-surface-alt'}
      >
        <ReactQueryFetcher
          reactQuery={useContentHomeInfoQuery}
          variables={{seriesId}}
          loadingWrapperClassName={twMerge(
            !isMobile && 'bg-theme-bg-surface-alt'
          )}
        >
          {({contentHomeInfo}) => (
            <div className={isMobile ? 'px-11pxr pt-8pxr' : undefined}>
              <ContentHomeAboutContainer
                seriesId={seriesId}
                aboutData={contentHomeInfo?.about}
                recommendData={contentHomeInfo?.recommend}
              />
            </div>
          )}
        </ReactQueryFetcher>
      </ApiErrorBoundary>
    </ContentHomeTabWrapper>
  );
}
